import { CircularProgress, Box, Text } from '@chakra-ui/react';
import styled from '@emotion/styled';
import { AxiosError } from 'axios';
import React from 'react';
import { ErrorIcon } from 'static/icons';

const BoxStyled = styled(Box)`
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  user-select: none;
  z-index: 100;
  background-color: rgba(242, 244, 247, 0.9);
  height: 100vh;
`;

export const Loader: React.FC<{
  loading?: boolean;
  error?: AxiosError<unknown> | boolean;
}> = ({ loading, error }) => (
  <>
    {(loading || error) && (
      <BoxStyled>
        {loading ? (
          <CircularProgress isIndeterminate />
        ) : (
          <Box
            display="flex"
            flexDirection="column"
            justifyContent="center"
            alignItems="center"
          >
            <ErrorIcon />
            <Text textStyle="h4">Ошибка</Text>
            <Text textStyle="body1" color="asphalt.1" textAlign="center">
              Проверьте правильность ввода и попробуйте ещё раз
            </Text>
          </Box>
        )}
      </BoxStyled>
    )}
  </>
);
